import React, { useState, useEffect } from 'react'
import ContentBox from '../components/ContentBox'
import Header from '../components/home/Header';
import FaqApi from '../services/robinhood/FaqsApi';
import FaqsCategoriasApi from '../services/robinhood/FaqsCatergoriasApi';
import ParametrosApi from '../services/robinhood/ParametrosApi';
import { Link } from 'react-router-dom';

export default function Faqs() {
  const [faqs, setFaqs] = useState([]);
  const [faqsVideoUrl, setFaqsVideoUrl] = useState(null);
  const [faqsChatbot, SetfaqsChatbot] = useState(null);
  const parametrosApi = new ParametrosApi();

  useEffect(() => {
    document.getElementById('toggle-menu').className = 'theme-blush';
    start();

  }, []);

  const start = async () => {
    await new FaqApi().all().then((response) => {
      setFaqs(response);
    });

    parametrosApi.all().then(response => {
      response.map(parametro => {
        if (parametro.id == parametrosApi.faqs_video_url) {
          if (response) {
            setFaqsVideoUrl(parametro.valor);
          }
        }
        if (parametro.id == parametrosApi.faqs_chatbot) {
          if (response) {
            SetfaqsChatbot(parametro.valor);
          }
        }
      });
    });


  }

  const FaqsCountComponent = () => {
    return <div className="col-lg-3 col-sm-6 col-md-6 col-xs-12">
      <div className="card" style={{ backgroundColor: '#7F99A6', cursor: 'default' }}>
        <div className="body text-white">
          <h4 style={{ marginBottom: '0px' }}><i className='zmdi zmdi-help-outline' style={{ fontSize: '30px', color: 'lightgreen' }}></i> {faqs.length} QUESTÕES </h4>
          <span className='m-l-30'>PERGUNTAS MAIS FREQUENTES</span>
        </div>
      </div>
    </div>
  }

  const ChatBotCountComponent = () => {
    return <div className="col-lg-3 col-sm-6 col-md-6 col-xs-12">
      <Link to={'/chatbot'} className='text-decoration-none'>
        <div className="card bg-blue-grey">
          <div className="body text-white">
            <h4 style={{ marginBottom: '0px' }}><i className='zmdi zmdi-comment-text-alt' style={{ fontSize: '30px', color: 'lightgreen' }}></i> CHATBOT </h4>
            <span className='m-l-30'> AJUDA POR  INTELIGÊNCIA ARTIFICIAL</span>
          </div>
        </div>
      </Link>
    </div>
  }

  const YoutubeLinkComponent = () => {
    return <div className="col-lg-4 col-sm-6 col-md-6 col-xs-12">
      <div className="card bg-blue-grey">
        <a href={faqsVideoUrl} className='small text-white' style={{ textDecoration: 'none', color: 'white' }} target='_blank'>
          <div className="body text-white">
            <h4 style={{ marginBottom: '0px' }}><i className='zmdi zmdi-youtube-play' style={{ fontSize: '30px', color: 'lightgreen' }}></i> TUTORIAL </h4>
            <span className='m-l-30'> <i className='zmdi zmdi-link'></i> ACESSE NOSSO VIDEO TUTORIAL NO YOUTUBE </span>
          </div>
        </a>
      </div>
    </div>
  }

  const CollapseComponent = () => {
    const collapse = [];
    collapse.push(
      faqs.map((faq) => {
        return (
          <div className="panel-group" id={`accordion_${faq.id}`} role="tablist" aria-multiselectable="true" key={Math.random()}>
            <div className="panel panel-col-blue-grey">
              <div className="panel-heading" role="tab" id={`headingOne_${faq.id}`}>
                <h4 className="panel-title rounded"><a role="button" data-toggle="collapse" data-parent={`#accordion_${faq.id}`} href={`#collapseOne_${faq.id}`} aria-expanded="true" aria-controls={`collapseOne_${faq.id}`}> {faq.faq}<i className='zmdi right zmdi-caret-down '></i> </a></h4>
              </div>
              <div id={`collapseOne_${faq.id}`} className="panel-collapse collapse in" role="tabpanel" aria-labelledby={`headingOne_${faq.id}`}>
                <div className="anel-body" dangerouslySetInnerHTML={{ __html: faq.resposta }}></div>
              </div>
            </div>
          </div>
        );
      })
    );
    return collapse;
  };

  return (
    <>
      <Header>
        <h5 style={{ marginLeft: '', marginBottom: '-30px' }}> <i className='zmdi zmdi-help'></i> FAQ - FREQUENTLY ASKED QUESTIONS  </h5>
      </Header>
      <section className="content">
        <div className='container-fluid"'>
          <div className="row clearfix">
            <FaqsCountComponent />
            {faqsVideoUrl && <YoutubeLinkComponent />}
            {faqsChatbot && <ChatBotCountComponent />}
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="card">
                <div className="header">
                  <h2> CASO SUA DÚVIDA NAO ESTEJA NA LISTA ENTRE EM CONTATO PELO EMAIL  <small> <i className='zmdi zmdi-email small'></i> leirobin@fjp.mg.gov.br  <code></code> </small> </h2>
                </div>
                <div className="body">
                  <div className="row clearfix">
                    <div className="col-md-12 col-lg-12">
                      <CollapseComponent />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
